import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Layout
import AdminLayout from './components/layout/AdminLayout';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import InquiriesPage from './pages/InquiriesPage';
import InquiryDetailPage from './pages/InquiryDetailPage';
import ClientsPage from './pages/ClientsPage';
import ClientDetailPage from './pages/ClientDetailPage';
import ProposalsPage from './pages/ProposalsPage';
import ProposalEditorPage from './pages/ProposalEditorPage';
import EngagementsPage from './pages/EngagementsPage';
import EngagementDetailPage from './pages/EngagementDetailPage';
import EngagementEditorPage from './pages/EngagementEditorPage';
import EngagementsCalendarPage from './pages/EngagementsCalendarPage';
import InvoicesPage from './pages/InvoicesPage';
import InvoiceDetailPage from './pages/InvoiceDetailPage';
import InvoiceEditorPage from './pages/InvoiceEditorPage';
import BlogPostsPage from './pages/BlogPostsPage';
import BlogEditorPage from './pages/BlogEditorPage';

// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

function App() {
  const { loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto mb-4"></div>
          <p className="text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected Admin Routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        
        {/* Inquiries */}
        <Route path="inquiries" element={<InquiriesPage />} />
        <Route path="inquiries/:id" element={<InquiryDetailPage />} />
        
        {/* Clients */}
        <Route path="clients" element={<ClientsPage />} />
        <Route path="clients/:id" element={<ClientDetailPage />} />
        
        {/* Proposals */}
        <Route path="proposals" element={<ProposalsPage />} />
        <Route path="proposals/new" element={<ProposalEditorPage />} />
        <Route path="proposals/:id" element={<ProposalEditorPage />} />
        
        {/* Engagements */}
        <Route path="engagements" element={<EngagementsPage />} />
        <Route path="engagements/calendar" element={<EngagementsCalendarPage />} />
        <Route path="engagements/new" element={<EngagementEditorPage />} />
        <Route path="engagements/:id" element={<EngagementDetailPage />} />
        <Route path="engagements/:id/edit" element={<EngagementEditorPage />} />
        
        {/* Invoices */}
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="invoices/new" element={<InvoiceEditorPage />} />
        <Route path="invoices/:id" element={<InvoiceDetailPage />} />
        <Route path="invoices/:id/edit" element={<InvoiceEditorPage />} />
        
        {/* Blog */}
        <Route path="blog" element={<BlogPostsPage />} />
        <Route path="blog/new" element={<BlogEditorPage />} />
        <Route path="blog/:id" element={<BlogEditorPage />} />
      </Route>

      {/* Catch all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
